import { render } from "./ChapterDialog.vue?vue&type=template&id=b922263a&scoped=true"
import script from "./ChapterDialog.vue?vue&type=script&lang=js"
export * from "./ChapterDialog.vue?vue&type=script&lang=js"

import "./ChapterDialog.vue?vue&type=style&index=0&id=b922263a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b922263a"]])

export default __exports__